/* ════════════════════════════════════════════════════════════════════
   MAPASA DROP — JS del tema (sin dependencias)
   · menú móvil (drawer)
   · ficha: selector de variante (color+talla) → precio/foto/disponible
   · cesta: −/+ y quitar vía /cart/change.js, barra de envío gratis
   ════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";
  var CFG = window.MAPASA || { umbralEnvioGratis: 7400, rutas: { cart: "/cart", cartChange: "/cart/change.js", cartAdd: "/cart/add.js" } };

  function eur(cents) {
    return (cents / 100).toLocaleString("es-ES", { style: "currency", currency: CFG.moneda || "EUR" });
  }

  /* ── Menú móvil ── */
  document.addEventListener("click", function (e) {
    var abre = e.target.closest("[data-mp-abre-menu]");
    var cierra = e.target.closest("[data-mp-cierra-menu]");
    var drawer = document.querySelector("[data-mp-drawer]");
    if (!drawer) return;
    if (abre) { drawer.classList.add("abierto"); document.body.style.overflow = "hidden"; }
    if (cierra) { drawer.classList.remove("abierto"); document.body.style.overflow = ""; }
  });

  /* ── Ficha: variantes ── */
  var ficha = document.querySelector("[data-mp-ficha]");
  if (ficha) {
    var variantes = JSON.parse(ficha.querySelector("[data-mp-variantes]").textContent);
    var form = ficha.querySelector("form[data-mp-form-producto]");
    var inputId = form.querySelector('input[name="id"]');
    var precioEl = ficha.querySelector("[data-mp-precio]");
    var btn = form.querySelector("[data-mp-anadir]");
    var fotoPpal = ficha.querySelector("[data-mp-foto-ppal]");

    function seleccion() {
      var opts = [];
      ficha.querySelectorAll("[data-mp-opcion]").forEach(function (grupo) {
        var marcado = grupo.querySelector("input:checked");
        if (marcado) opts.push(marcado.value);
      });
      return opts;
    }

    function variantePara(opts) {
      return variantes.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function pinta() {
      var v = variantePara(seleccion());
      ficha.querySelectorAll("[data-mp-valor-opcion]").forEach(function (el) {
        var grupo = el.closest("[data-mp-opcion]");
        var marcado = grupo.querySelector("input:checked");
        if (marcado) el.textContent = marcado.value;
      });
      if (!v) {
        btn.disabled = true;
        btn.textContent = "Combinación no disponible";
        return;
      }
      inputId.value = v.id;
      if (precioEl) precioEl.textContent = eur(v.price);
      if (v.available) {
        btn.disabled = false;
        btn.textContent = btn.dataset.textoAnadir || "Añadir a la cesta";
      } else {
        btn.disabled = true;
        btn.textContent = "Agotada en esta combinación";
      }
      if (v.featured_image && fotoPpal) {
        var img = fotoPpal.querySelector("img");
        if (img) { img.src = v.featured_image.src; img.srcset = ""; }
      }
      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      window.history.replaceState({}, "", url.toString());
    }

    ficha.addEventListener("change", function (e) {
      if (e.target.closest("[data-mp-opcion]")) pinta();
    });
    pinta();

    /* Galería: miniaturas → principal */
    ficha.addEventListener("click", function (e) {
      var mini = e.target.closest("[data-mp-mini]");
      if (!mini || !fotoPpal) return;
      var img = fotoPpal.querySelector("img");
      if (img) { img.src = mini.dataset.src; img.srcset = ""; }
      ficha.querySelectorAll("[data-mp-mini]").forEach(function (b) { b.classList.remove("activa"); });
      mini.classList.add("activa");
    });
  }

  /* ── Cesta: cantidad / quitar / barra de envío ── */
  function pintaBarraEnvio(totalCents) {
    var barra = document.querySelector("[data-mp-envio-barra]");
    if (!barra) return;
    var umbral = CFG.umbralEnvioGratis;
    var texto = barra.querySelector("[data-mp-envio-texto]");
    var relleno = barra.querySelector("[data-mp-envio-relleno]");
    var falta = umbral - totalCents;
    if (relleno) relleno.style.width = Math.min(100, (totalCents / umbral) * 100) + "%";
    if (texto) {
      texto.innerHTML = falta > 0
        ? "Te faltan <strong>" + eur(falta) + "</strong> para el envío gratis."
        : "<strong>Envío gratis desbloqueado</strong> — premio.";
    }
  }

  function cambiaLinea(key, qty) {
    return fetch(CFG.rutas.cartChange, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Re-render simple y robusto: recargamos la página de cesta con el estado real.
        if (document.querySelector("[data-mp-cesta-pagina]")) window.location.reload();
        else actualizaBadge(cart.item_count);
        return cart;
      });
  }

  function actualizaBadge(count) {
    document.querySelectorAll("[data-mp-cesta-badge]").forEach(function (b) {
      b.textContent = count;
      b.setAttribute("data-count", count);
    });
  }

  document.addEventListener("click", function (e) {
    var mas = e.target.closest("[data-mp-qty-mas]");
    var menos = e.target.closest("[data-mp-qty-menos]");
    var quitar = e.target.closest("[data-mp-quitar]");
    var linea = e.target.closest("[data-mp-linea]");
    if (!linea) return;
    var key = linea.dataset.key;
    var qty = parseInt(linea.dataset.qty, 10);
    if (mas) cambiaLinea(key, qty + 1);
    if (menos && qty > 1) cambiaLinea(key, qty - 1); // mínimo 1; quitar es explícito
    if (quitar) cambiaLinea(key, 0);
  });

  var cestaPagina = document.querySelector("[data-mp-cesta-pagina]");
  if (cestaPagina) pintaBarraEnvio(parseInt(cestaPagina.dataset.total, 10));
})();

/* ════════════════════════════════════════════════════
   V2 — QUICK-VIEW + PACK MINI-ME (réplica del motor web)
   ════════════════════════════════════════════════════ */
(function () {
  "use strict";
  var CFG = window.MAPASA || { rutas: { cart: "/cart", cartAdd: "/cart/add.js" } };
  function eur(cents) {
    return (cents / 100).toLocaleString("es-ES", { style: "currency", currency: CFG.moneda || "EUR" });
  }
  function actualizaBadge(count) {
    document.querySelectorAll("[data-mp-cesta-badge]").forEach(function (b) {
      b.textContent = count;
      b.setAttribute("data-count", count);
    });
  }
  function toast(html) {
    var t = document.querySelector("[data-mp-toast]");
    if (!t) return;
    t.querySelector("span").innerHTML = html;
    t.classList.add("visible");
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove("visible"); }, 4500);
  }
  function anadir(items) {
    return fetch(CFG.rutas.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || "No se pudo añadir"); });
      return fetch("/cart.js").then(function (rc) { return rc.json(); }).then(function (cart) {
        actualizaBadge(cart.item_count);
        return cart;
      });
    });
  }

  /* ── QUICK-VIEW: botón «vistazo» en las cards de colección ── */
  var qv = document.querySelector("[data-mp-qv]");
  function cierraQv() { if (qv) { qv.classList.remove("abierto"); document.body.style.overflow = ""; } }

  document.addEventListener("click", function (e) {
    var boton = e.target.closest("[data-mp-vistazo]");
    if (boton && qv) {
      e.preventDefault();
      abreQv(boton.dataset.handle);
      return;
    }
    if (e.target.closest("[data-mp-qv-cierra]")) cierraQv();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") cierraQv(); });

  function abreQv(handle) {
    fetch("/products/" + handle + ".js")
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var cuerpo = qv.querySelector("[data-mp-qv-cuerpo]");
        var selects = p.options
          .map(function (o, i) {
            var valores = o.values
              .map(function (v) { return '<option value="' + v.replace(/"/g, "&quot;") + '">' + v + "</option>"; })
              .join("");
            return (
              '<div class="mp-qv__opcion"><p class="mp-opcion__label">' + o.name + "</p>" +
              '<select data-mp-qv-opt="' + i + '">' + valores + "</select></div>"
            );
          })
          .join("");
        cuerpo.innerHTML =
          '<div class="mp-qv__foto">' +
          (p.featured_image ? '<img src="' + p.featured_image + '" alt="">' : '<div class="mp-foto-placeholder">foto</div>') +
          "</div>" +
          "<div>" +
          '<h3 class="mp-qv__titulo">' + p.title + "</h3>" +
          '<p class="mp-qv__precio" data-mp-qv-precio>' + eur(p.price) + "</p>" +
          selects +
          '<button type="button" class="mp-btn mp-btn--primario mp-btn--block" style="margin-top:20px;" data-mp-qv-anadir>Añadir a la cesta</button>' +
          '<p class="mp-qv__ok mp-oculto" data-mp-qv-ok></p>' +
          '<a class="mp-qv__enlace" href="/products/' + p.handle + '">Ver la ficha completa →</a>' +
          "</div>";
        qv._producto = p;
        pintaQv();
        qv.classList.add("abierto");
        document.body.style.overflow = "hidden";
      });
  }

  function seleccionQv() {
    return Array.prototype.map.call(qv.querySelectorAll("[data-mp-qv-opt]"), function (s) { return s.value; });
  }
  function varianteQv() {
    var opts = seleccionQv();
    return (qv._producto.variants || []).find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  }
  function pintaQv() {
    var v = varianteQv();
    var btn = qv.querySelector("[data-mp-qv-anadir]");
    var precio = qv.querySelector("[data-mp-qv-precio]");
    if (!btn) return;
    if (!v) { btn.disabled = true; btn.textContent = "Combinación no disponible"; return; }
    btn.disabled = !v.available;
    btn.textContent = v.available ? "Añadir a la cesta" : "Agotada en esta combinación";
    if (precio) precio.textContent = eur(v.price);
    if (v.featured_image && v.featured_image.src) {
      var img = qv.querySelector(".mp-qv__foto img");
      if (img) img.src = v.featured_image.src;
    }
  }
  if (qv) {
    qv.addEventListener("change", function (e) { if (e.target.closest("[data-mp-qv-opt]")) pintaQv(); });
    qv.addEventListener("click", function (e) {
      if (!e.target.closest("[data-mp-qv-anadir]")) return;
      var v = varianteQv();
      if (!v) return;
      anadir([{ id: v.id, quantity: 1 }])
        .then(function () {
          var ok = qv.querySelector("[data-mp-qv-ok]");
          if (ok) { ok.classList.remove("mp-oculto"); ok.textContent = "En la cesta ✓"; }
          toast('Añadida. <a href="' + CFG.rutas.cart + '">Ir a la cesta →</a>');
          setTimeout(cierraQv, 900);
        })
        .catch(function (err) { toast(err.message); });
    });
  }

  /* ── PACK MINI-ME: talla por pieza, un botón, un solo add ── */
  var pack = document.querySelector("[data-mp-pack]");
  if (pack) {
    function estadoPack() {
      var piezas = [];
      pack.querySelectorAll("[data-mp-pack-pieza]").forEach(function (p) {
        var dentro = p.querySelector("[data-mp-pack-check]").checked;
        p.classList.toggle("fuera", !dentro);
        var sel = p.querySelector("[data-mp-pack-variante]");
        var opcion = sel.options[sel.selectedIndex];
        piezas.push({
          dentro: dentro,
          id: parseInt(sel.value, 10),
          precio: parseInt(opcion.dataset.precio, 10),
          disponible: opcion.dataset.disponible === "true",
        });
      });
      return piezas;
    }
    function pintaPack() {
      var piezas = estadoPack().filter(function (p) { return p.dentro; });
      var total = piezas.reduce(function (s, p) { return s + p.precio; }, 0);
      var totalEl = pack.querySelector("[data-mp-pack-total]");
      if (totalEl) totalEl.textContent = eur(total);
      var envio = pack.querySelector("[data-mp-pack-envio]");
      if (envio) envio.classList.toggle("mp-oculto", total < (CFG.umbralEnvioGratis || 7400));
      var btn = pack.querySelector("[data-mp-pack-anadir]");
      var sinStock = piezas.some(function (p) { return !p.disponible; });
      btn.disabled = piezas.length === 0 || sinStock;
      btn.textContent = sinStock ? "Alguna pieza está agotada en esa talla" : "Añadir el look completo";
    }
    pack.addEventListener("change", pintaPack);
    pack.addEventListener("click", function (e) {
      if (!e.target.closest("[data-mp-pack-anadir]")) return;
      var items = estadoPack()
        .filter(function (p) { return p.dentro && p.disponible; })
        .map(function (p) { return { id: p.id, quantity: 1 }; });
      if (!items.length) return;
      anadir(items)
        .then(function () { toast('Look completo en la cesta. <a href="' + CFG.rutas.cart + '">Ir a la cesta →</a>'); })
        .catch(function (err) { toast(err.message); });
    });
    pintaPack();
  }
})();
